<span *ngIf="errorMessage !== null" class="general-error">
	<span class="di di-alert error-message"></span>{{ errorMessage | translate }}
</span>

<com-avl-cal-awakening-calendar
    *ngIf="!hideAvailabilityCalendar"
    [dates]="availableDates"
    [dateTypeMap]="dateTypeMap"
    [selectedDates]="selectedDates"
    [defaultDate]="defaultDate"
    [displayStrictNumMonths]="displayStrictNumMonths"
    (com-calendar.selection-updated)="getParksAvailability($event)"
    (com-calendar.navigation-change)="getAvailabilityForSelectedSegment($event)"
></com-avl-cal-awakening-calendar>

<com-avl-cal-awakening-information
    title="{{reservationsTitle | translate: [selectedDate.formatted]}}"
    [availableParks]="selectedDate.availability"
    [showAIComponent]="showAIComponent"
    disclaimer="{{reservationsDisclaimer | translate}}"
></com-avl-cal-awakening-information>
